import * as React from 'react';
import { makeStyles } from '@fluentui/react-components';
import { useAuth } from '../auth/AuthContext';
import AdminLogin from '../auth/AdminLogin';
import Dashboard from './Dashboard';
import themeImage from '../assets/theme.jpg';
import { FONT_FAMILY } from './sharedStyles';
import { ADMIN_SECTION_CONSTANTS } from '../constants/adminSectionConstants';

interface AdminSectionProps {
  setActiveSection: (section: 'home' | 'schedule' | 'faq' | 'rsvp' | 'admin') => void;
}

const useStyles = makeStyles({
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    background: `url(${themeImage}) center/cover no-repeat fixed, linear-gradient(to bottom right, #fff8e1, #ffe0b2)`,
    fontFamily: FONT_FAMILY,
  },
  loadingCard: {
    background: 'rgba(255, 253, 248, 0.95)',
    padding: '2rem',
    borderRadius: '15px',
    textAlign: 'center',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
  },
  loadingText: {
    color: 'var(--primary-color)',
    fontSize: '1.2rem',
  },
});

const AdminSection: React.FC<AdminSectionProps> = ({ setActiveSection }) => {
  const classes = useStyles();
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className={classes.loadingContainer}>
        <div className={classes.loadingCard}>
          <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>{ADMIN_SECTION_CONSTANTS.LOADING.EMOJI}</div>
          <p className={classes.loadingText}>
            {ADMIN_SECTION_CONSTANTS.LOADING.MESSAGE}
          </p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <AdminLogin onLoginSuccess={() => {}} onBack={() => setActiveSection('home')} />;
  }

  return <Dashboard setActiveSection={setActiveSection} />;
};

export default AdminSection;